import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {IpopConfigurationRouteService} from './ipop-configuration-route.service';

@Injectable({
  providedIn: 'root'
})
export class IpopRuleWorkflowEnhancementFeatureGuard
{
  constructor(private ipopConfigurationRouteService: IpopConfigurationRouteService)
  {
  }

  /** Allows enhanced access or redirects through the approved fallback order. */
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree>
  {
    const routeDecision = this.ipopConfigurationRouteService.resolveEnhancedRoute(route);

    return routeDecision;
  }
}
